module.exports = __webpack_public_path__ + "3eb3b3d4a97eae0de49e5f3fd25b9301.svg";